import styled from 'styled-components';

export const StyledCardWrapper = styled.div`
  border-radius: ${(props) => props.theme.radius.md};
  background-color: ${(props) => props.theme.color.white};
  box-shadow: 0px 0px 20px 0px #a6adb340;
  padding: 1.5rem;
  gap: 1rem;

  display: flex;
  flex-direction: column;
`;

export const StyledContent = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const StyledImageWrapper = styled.div<{ $imgSrc: string }>`
  background-image: ${(props) => `url(${props.$imgSrc})`};
  position: relative;
  background-size: cover;
  width: 30%;
  aspect-ratio: 1;
  border-radius: ${(props) => props.theme.radius.md};

  @media (max-width: 768px) {
    max-width: 100%;
    width: 100%;
    max-height: 250px;
  }
`;

export const StyledOpenImages = styled.div`
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  padding: 0.75rem;
  background-color: ${(props) => props.theme.color.offWhite};
  border: 1px solid ${(props) => props.theme.color.bodyTextColor};
  color: ${(props) => props.theme.color.bodyTextColor};
  border-radius: ${(props) => props.theme.radius.md};
  transition: scale 0.2s ease-out;
  &:hover {
    cursor: pointer;
    scale: 1.1;
  }
`;

export const StyledInfo = styled.div`
  width: 100%;
`;

export const StyledHeader = styled.div`
  display: flex;
  width: 100%;
`;
